import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { formatOfficeClock, msUntilNextSecond } from '../state/office-clock.js';

/** HUD clock showing the office's local time (Europe/Stockholm), ticking over on each second. */
export function OfficeClock() {
  const { t } = useTranslation();
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const timer = window.setTimeout(() => setNow(new Date()), msUntilNextSecond(now));
    return () => window.clearTimeout(timer);
  }, [now]);

  const time = formatOfficeClock(now);
  return (
    <div className="hud-box clock" role="timer" aria-label={t('hud.clock', { time })}>
      <time dateTime={now.toISOString()} aria-hidden="true">
        {time}
      </time>
    </div>
  );
}
